import { createContext } from 'react';
import { TrackEvent, User } from '@hkgai/tracker-sdk';
import type { UserInfo } from '@hkgai/pb-fe-api/lib/interface/meeting_api';

interface GlobalContextValue {
  lang?: string;
  setLang?: (value: string) => void;
  userInfo?: UserInfo & { meetingOnlyUser?: number };
  collectEvent?: (events: TrackEvent[]) => void;
  setUserInfo?: (user: User & { meetingOnlyUser?: number }) => void;
}

export const GlobalContext = createContext<GlobalContextValue>({});

export const AuthContext = createContext<{
  user: User;
}>(null!);
